"use client";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const LeagueFilterV12 = ({ searchTerm, onSearchChange, className = "" }) => {
  return (
    <div
      className={`relative flex items-center w-full bg-[var(--theme-foreground)] rounded-lg kbv-search-shadow-navy-slate overflow-hidden ${className}`}
    >
      <div className="absolute left-0 top-0 bottom-0 w-[30px] flex items-center justify-center text-[var(--theme-primary)] pointer-events-none">
        <MagnifyingGlassIcon className="h-[17px] w-[17px]" aria-hidden />
      </div>
      <input
        type="text"
        className="w-full h-[38px] pl-[30px] pr-3 border-none outline-none text-sm text-[var(--theme-text)] placeholder:text-[var(--theme-text-muted)]"
        placeholder="Tìm tên đội hoặc giải"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};

export default LeagueFilterV12;
